@use '../../../utils.scss';
@use '../../../base-variables.scss';

.DropDown {
	outline: none;
	position: relative;
	border: 1px solid utils.color('standby-blue-gray');
	border-radius: 5px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 6px 0 16px;
	&.Active {
		border-color: utils.color('nebula');
		box-shadow: base-variables.$active-shadow;
	}
	& > span {
		margin-bottom: 2px;
	}

	&.Disabled{
		opacity: 0.33; 
	}

	.SelectedOptionContainer {
		display: flex;
		align-items: center;
		max-width: calc(100% - 16px);
    	overflow: hidden;
		.Text {
			width: 100%;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		svg {
			margin-right: 16px;
			margin-left: 0px;
			// max-height: 15px;
			width: 20px;
		}
	}
}

.Arrow {
	// height: 10px;
	// width: 11px;
	margin-top: 2px;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.RotatedArrow {
	// height: 10px !important;
	// width: 11px !important;
	transform: rotate(90deg);
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.RightSideDiv {
	padding-right: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	> svg {
		margin-left: 8px;
	}
	}